module.exports = {
  i18n: {
    locales: ['en', 'vn'],
    defaultLocale: 'en',
  },
  defaultNS: 'common',
};
